export default {
  ANALYTICS: {
    TRACKER_ID: 'UA-78663608-1',
  },
  AIRFLOW_URL: 'https://dev-af.copilot.choreograph.com',
  MAPBOX_PUBLIC_TOKEN: 'pk.eyJ1IjoieGF4Y29waWxvdGVuZ2luZWVycyIsImEiOiJja2JsYjE0YTgwNmRlMnJuOHJtbnl0OGlzIn0.4nB0y3WL9lcuw9lFRBBt1Q',
  ENV: 'dev',
};
